// extracted by mini-css-extract-plugin
export const root = "initiative-featured-media-module--root--2Lp7L";
export const image = "initiative-featured-media-module--image--1cqFf";
export const video = "initiative-featured-media-module--video--3VZac";
export const videoWrap = "initiative-featured-media-module--videoWrap--31G4i";
export const cover = "initiative-featured-media-module--cover--1EqIT";
export const action = "initiative-featured-media-module--action--36Qu1";
export const player = "initiative-featured-media-module--player--1QD71";
export const active = "initiative-featured-media-module--active--1PVu1";